interface ErrorMessageProps {
  message: string;
}

export default function ErrorMessage({ message }: ErrorMessageProps) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow p-6 max-w-md mx-auto text-center">
        <h1 className="text-xl font-semibold text-gray-900">Page Not Available</h1>
        <p className="mt-2 text-gray-500">{message}</p>
      </div>
    </div>
  );
}
